export default __webpack_public_path__ + "static/media/premiumplus_hrv.c3c1c8f6.png";